const idleState = {context: "hidden", isCancelling: false, errorText: "", currentPin: "", newUser: {firstName: "", lastName: ""}}
const initialState = {...idleState, session: null, sessions: []}

const pinNumberClicked = (state, payload) => ({
  ...state, errorText: null, currentPin: state.currentPin + (state.currentPin.length > 3 ? "" : payload.number)
})

const isBlank = (s) => (!s || /^\s*$/.test(s))

const confirmNewUser = (state) => (
  state.currentPin === state.newUser.pin ? state : {...state, context: "new_user", currentPin: "", errorText: "Pin's do not match"}
)

const setNewUserPin = (state) => {
  if (isBlank(state.newUser.firstName) || isBlank(state.newUser.lastName)) {
    return {...state, errorText: "Please enter first and last name"}
  } else {
    return {
      ...state, context: "new_user_confirmation", currentPin: "",
      newUser: {...state.newUser, pin: state.currentPin}
    }
  }
}

const backContext = (currentContext) => {
  switch (currentContext) {
    case "starting_cash":
    case "ending_cash":
    case "stats1":
    case "cash_balance":
      return "clock_out"
    default:
      return "clock_in"
  }
}

const errorContext = (currentContext) => {
  return currentContext === "new_user_confirmation" ? "new_user" : currentContext
}

const cashDone = (state, {cashAmount}) => {
  switch (state.context) {
    case "starting_cash":
      return {...state, ...idleState}
    case "ending_cash":
      const amount = cashAmount ? parseFloat(cashAmount) : 0
      return {...state, context: "cash_balance", endingCashAmountEntered: amount}
    default:
      return state
  }
}

const saveNewSession = (state, payload) => {
  const sessions = state.sessions
  const receivedSession = payload.session
  const index = state.sessions.findIndex(s => s.id == receivedSession.id)
  const nextSessions = (index === -1) ?
    [receivedSession, ...sessions] : [...sessions.slice(0, index), receivedSession, ...sessions.slice(index + 1)]
  return {...state, sessions: nextSessions, lastSessionId: receivedSession.id}
}

const destroySession = (state, id) => {
  const index = state.sessions.findIndex(s => s.id == id)
  if (index === -1) return state
  const nextSessions = [...state.sessions.slice(0, index), ...state.sessions.slice(index + 1)]
  return {...state, sessions: nextSessions, lastSessionId: null}
}

const clockIn = (state = initialState, {type, payload}) => {
  switch (type) {
    case "SLIDING_PANELS.INIT":
      return {...state, ...App.clockIn}
    case "CLOCK_IN.BACK_CLICKED":
      return {...state, ...idleState, context: backContext(state.context)}
    case "CLOCK_IN.CANCEL":
      return {...state, ...idleState}
    case "CLOCK_IN.CONFIRM_NEW_USER":
      return confirmNewUser(state)
    case  "CLOCK_IN.DESTROY_SESSION":
      return destroySession(state, payload.id)
    case "CLOCK_IN.NO_LIMIT_BUTTON_CLICKED":
      return { ...state, context: state.sessions.length ? "clock_out" : "clock_in", loading: false, locationParams: { params: { locations: [true] } } }
    case "CLOCK_IN.HEADER_USER_BUTTON_CLICKED":
      return { ...state, context: state.sessions.length ? "clock_out" : "clock_in", loading: true }
    case "CLOCK_IN.LOCATION_RECEIVED":
      return {...state, context: state.sessions.length ? "clock_out" : "clock_in", loading: false, locationParams: {...payload}}
    case "CLOCK_IN.LOCATION_FAILED":
      return { ...state, context: state.sessions.length ? "clock_out" : "clock_in", loading: false, locationParams: {params: {locations: []}}}
    case "CLOCK_IN.NEW_USER_CHANGED":
      return {...state, newUser: {...state.newUser, ...payload}}
    case "CLOCK_IN.NEW_USER":
      return {...state, ...idleState, context: "new_user"}
    case "CLOCK_IN.NEW_USER_SUCCESS":
      return {...state, context: "new_user_done"}
    case "CLOCK_IN.ERROR":
      return {...state, context: errorContext(state.context), currentPin: "", errorText: payload.errorText}
    case "CLOCK_IN.PIN_NUMBER_CLICKED":
      return pinNumberClicked(state, payload)
    case "CLOCK_IN.PIN_NUMBER_DELETE":
      return {...state, currentPin: state.currentPin.slice(0, -1)}
    case "CLOCK_IN.GET_ENDING_CASH":
      return {...state, context: "ending_cash"}
    case "CLOCK_IN.GET_STARTING_CASH":
      return {...state, context: "starting_cash"}
    case "CLOCK_IN.SET_NEW_USER_PIN":
      return setNewUserPin(state)
    case "CLOCK_IN.CONFIRM_CLOCK_OUT":
    case "CLOCK_IN.START_CANCEL":
      return {...state, isCancelling: true}
    case "CLOCK_IN.STATS":
      return {...state, context: "stats1"}
    case "CLOCK_IN.CASH_DONE":
      return cashDone(state, payload)
    case "CLOCK_IN.SAVE_NEW_SESSION":
      return saveNewSession(state, payload)
    case "CLOCK_IN.SESSION":
      return {...state, ...payload}
    default:
      return state
  }
}

export default clockIn
